var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    enableBackground: "new 0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 13.6488,
    y1: 43.0266,
    x2: 28.0221,
    y2: 23.1623
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#9E1F63"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B62A8"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M7.582,46.218c0-1.003,0.281-1.947,0.77-2.782c0.247-0.598,0.641-1.159,1.187-1.638l6.296-5.522 l3.033-2.66l2.005-1.758l-2.61-2.252L7.138,39.363c-3.411,2.991-3.6,8.048-0.192,11.042c1.711,1.503,3.959,2.254,6.207,2.254 c1.147,0,2.293-0.198,3.368-0.589c-0.627,0.163-1.29,0.254-1.978,0.254C10.699,52.323,7.582,49.59,7.582,46.218z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 0.7503,
    y1: 45.8677,
    x2: 50.1157,
    y2: 45.8677
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#372BB3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6989,
    style: {
      stopColor: "#F05A28"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9946,
    style: {
      stopColor: "#F6921E"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M56.286,42.018c0.198,0.567,0.306,1.168,0.306,1.792c0,3.372-3.116,6.105-6.961,6.105 c-1.324,0-2.558-0.33-3.612-0.893c-0.532-0.217-1.024-0.511-1.45-0.885l-7.88-6.912l0.012-0.012 c-1.571-1.318-3.695-2.134-6.035-2.134c-2.642,0-5.009,1.037-6.613,2.667l0,0l-2.906,2.549l-4.254,3.731 c-1.836,1.611-4.792,1.893-6.847,0.501c-1.855-1.257-2.419-3.335-1.693-5.092c-0.489,0.835-0.77,1.779-0.77,2.782 c0,3.372,3.116,6.105,6.961,6.105c0.688,0,1.351-0.091,1.978-0.254c1.031-0.375,1.998-0.927,2.834-1.661l1.072-0.941l6.564-5.757 l-0.036-0.024c0.932-0.869,2.246-1.418,3.71-1.418c1.421,0,2.708,0.513,3.635,1.338l-0.032,0.036l7.713,6.765 c1.651,1.448,3.854,2.246,6.203,2.246c2.349,0,4.552-0.798,6.203-2.246c1.651-1.448,2.561-3.381,2.561-5.441 C56.948,43.938,56.72,42.94,56.286,42.018z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 50.2222,
    y1: 47.9652,
    x2: 51.0814,
    y2: 21.9577
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBB216"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0481,
    style: {
      stopColor: "#F1B219"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3839,
    style: {
      stopColor: "#AEB52D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6657,
    style: {
      stopColor: "#7DB73C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8794,
    style: {
      stopColor: "#5FB845"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#54B848"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M56.286,42.018c-0.434-0.921-1.074-1.767-1.9-2.491l-0.928-0.814l-5.907-5.181 c-0.715-0.627-1.874-0.627-2.589,0v0c-0.715,0.627-0.715,1.644,0,2.271l2.513,2.204l4.322,3.791 c0.96,0.842,1.488,1.968,1.488,3.17c0,1.202-0.529,2.328-1.488,3.17c-0.96,0.842-2.243,1.305-3.614,1.305 c-0.763,0-1.496-0.148-2.164-0.421c1.054,0.563,2.287,0.893,3.612,0.893c3.844,0,6.961-2.733,6.961-6.105 C56.592,43.187,56.485,42.585,56.286,42.018z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 5.096,
    y1: 15.5942,
    x2: 16.3127,
    y2: 12.612
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#25A9E0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1B75BB"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M26.15,14.761l-6.612-5.8C16.309,6.13,11.092,5.749,7.576,8.303 c-3.156,2.292-3.96,6.016-2.435,9.049c-0.226-0.601-0.352-1.242-0.352-1.91c0-3.372,3.116-6.105,6.961-6.105 c1.243,0,2.408,0.289,3.418,0.79c0.581,0.218,1.126,0.531,1.599,0.946l6.794,5.959c0.713,0.626,1.869,0.627,2.585,0.004l0,0 C26.864,16.409,26.866,15.39,26.15,14.761z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 4.2993,
    y1: 8.481,
    x2: 20.8669,
    y2: 24.2377
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0068AC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8B62A8"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M19.826,26.436l-5.919-5.191l-2.46-2.157L9.695,17.55c-2.035-1.785-2.152-4.809-0.069-6.551 c0.985-0.824,2.256-1.236,3.527-1.236c0.687,0,1.373,0.124,2.015,0.365c-1.01-0.501-2.175-0.79-3.418-0.79 c-3.844,0-6.961,2.733-6.961,6.105c0,0.668,0.127,1.309,0.352,1.91c0.425,0.845,1.02,1.64,1.809,2.331l0.119,0.105l0,0 l11.193,9.817l2.589-2.271L19.826,26.436z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.863,
    y1: 11.1187,
    x2: 17.4923,
    y2: 43.4893
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A69C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B388F"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M54.107,8.567c-2.54-2.043-6.119-2.455-9.172-1.401c0.606-0.151,1.243-0.237,1.904-0.237 c3.844,0,6.961,2.733,6.961,6.105c0,1.181-0.389,2.28-1.051,3.215c-0.242,0.425-0.558,0.819-0.95,1.163l-7.651,6.711l-0.975,0.855 l-0.002-0.001l-6.625,5.791l-2.101,1.843l-0.001-0.001c-0.935,0.904-2.28,1.476-3.777,1.476c-1.488,0-2.819-0.57-3.752-1.465 c-0.004,0.005-0.01,0.009-0.014,0.013l-3.457-3.03l1.739-1.525l2.506-2.198l2.981-2.615l2.589-2.271l6.953-6.098 c-0.214-0.587-0.332-1.213-0.332-1.862c0-1.294,0.462-2.492,1.245-3.48l-9.804,8.599h0l-4.489,3.937v0l-5.627,4.935l-0.351,0.308 l-2.589,2.271l2.61,2.252l0.002-0.002l0.276,0.242l0,0l0,0l3.342,2.931L24.525,35c1.575,1.393,3.731,2.274,6.141,2.274 c2.298,0,4.385-0.787,5.947-2.063l-0.108-0.129l0.116,0.132l2.313-2.015l7.05-6.144l8.403-7.37 c1.651-1.448,2.561-3.381,2.561-5.44C56.948,12.069,55.935,10.038,54.107,8.567z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 20.4349,
    y1: 31.6656,
    x2: 37.4526,
    y2: 33.8348
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8962A9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#157096"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M36.534,30.768l-2.101,1.843l-0.001-0.001c-0.935,0.904-2.28,1.476-3.777,1.476 c-1.488,0-2.819-0.57-3.752-1.465c-0.004,0.005-0.01,0.009-0.014,0.013l-3.457-3.03l-2.589-2.271l-0.001,0.001l-2.589,2.271 l2.61,2.252l0.002-0.002l0.276,0.242l3.342,2.931L24.514,35c1.575,1.393,3.731,2.274,6.141,2.274c2.298,0,4.385-0.787,5.947-2.063 l-0.108-0.129l0.116,0.132l2.313-2.015l1.371-1.195l-2.987-1.91L36.534,30.768z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.0922,
    y1: 10.5106,
    x2: 16.5529,
    y2: 43.05
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#00A69C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2B388F"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_8_)",
    d: "M39.012,15.948l5.558-4.875c0.996-0.874,2.305-1.311,3.614-1.311c1.309,0,2.617,0.437,3.614,1.311 c0.96,0.842,1.488,1.968,1.488,3.17c0,0.71-0.189,1.392-0.538,2.007c0.662-0.934,1.051-2.033,1.051-3.215 c0-3.372-3.116-6.105-6.961-6.105c-0.661,0-1.298,0.086-1.904,0.237c-1.144,0.395-2.217,0.989-3.13,1.79l-4.502,3.948 c-0.783,0.988-1.034,2-1.034,3.294C36.269,16.849,38.798,15.36,39.012,15.948z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpn);
export default __webpack_public_path__ + "static/media/CPN.5bab2d2091bed802be0bebf9352b1a1e.svg";
export { ForwardRef as ReactComponent };